// import DashboardTabs from "../../components/DashboardTabs/DashboardTabs";
// import ToDoList from "../../components/MockDesignToDoList/ToDoList";
import ProjectionCard from "../../components/Card/ProjectionCard/ProjectionCard";
// import Chat from "../../components/MockDesignChat/Home";
import * as service from "./TelerikReportList.service";
import { GetUserId, GetUserDetails } from "../../config/app.config.js";
export default {
  name: "TelerikReportList",
  components: {
    ProjectionCard
  },
  mounted() {
    this.getUserDetails();
    this.getReportTypes();
  },
  data() {
    return {
      reportTypes: [],
      selectedArea: "",
      selectedTeam: ""
    };
  },
  methods: {
    async getReportTypes() {
      var reports = await service.getReports();
      reports.data.forEach(report => {
        var reportType = {
          Product: "Report",
          Text1: report.ReportTitle,
          Text2: "",
          TileColor: report.TileColor,
          Icon: report.IconName,
          Icon_Title: "",
          Drill_Down: "true",
          Title: report.ReportName,
          RouterPath: this.generateUrl(report.UrlPath),
          Score_Color: report.ScoreColor
          //Score: "hidden"
        };

        this.reportTypes.push(reportType);
      });
    },
    generateUrl(url = "") {
      var generatedUrl = url
        .replace("{area}", this.selectedArea)
        .replace("{team}", this.selectedTeam);
      return generatedUrl;
    },
    getUserDetails() {
      let userDetails = GetUserDetails();
      this.selectedArea = userDetails.Area;
      this.selectedTeam = userDetails.Team;
    }
  }
};
